module.exports = __webpack_public_path__ + "img/set_up.035bc8c0.svg";